'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

WebApiService.$inject = ['$http', '$log', '$q', '$window', 'EnvironmentService', 'WebApiSharePointConstants', 'WebApiSitecoreConstants', 'WebApiMockService'];


var _module = _angular2.default.module('cb.webApi.service', []);

_module.factory('WebApiService', WebApiService);

exports.default = _module;


function WebApiService($http, $log, $q, $window, EnvironmentService, WebApiSharePointConstants, WebApiSitecoreConstants, WebApiMockService) {
    var service = {
        get: get,
        getParametersObject: getParametersObject
    };

    return service;

    function get(requestdata, control, deferred) {
        var WebApiConstants = WebApiSharePointConstants;

        if (EnvironmentService.isSitecore()) {
            WebApiConstants = WebApiSitecoreConstants;
        }

        deferred = deferred || $q.defer();

        if (typeof requestdata === 'undefined' || typeof control === 'undefined') {
            deferred.reject({
                'error': 'requestdata or control not specified'
            });
            return deferred.promise;
        }

        //Use vti_bin or WebApiProxy only on environments where they're available
        if (EnvironmentService.isProduction() || EnvironmentService.isAcceptance() || EnvironmentService.isTest() || EnvironmentService.isProxy()) {
            var url = WebApiConstants[control];

            // Request digest token is available on forms masterpage for logged in customers and is necessary for TrackAndTraceApi
            // This is reported as a bug and this code should be removed after the T&T api is fixed
            var requestDigest = void 0;
            if ($window.document.getElementById('__REQUESTDIGEST') || $window.document.getElementsByName('__REQUESTDIGEST').length > 0) {
                requestDigest = $window.document.getElementById('__REQUESTDIGEST') ? $window.document.getElementById('__REQUESTDIGEST').value : $window.document.getElementsByName('__REQUESTDIGEST')[0].value;
            }

            var config = {};

            if (requestDigest) {
                config.headers = {
                    'X-RequestDigest': requestDigest
                };
            }

            if (EnvironmentService.isSitecore()) {
                var verificationToken = _angular2.default.element(document.querySelector('input[name="__RequestVerificationToken"]'))[0];
                if (verificationToken) {
                    verificationToken = verificationToken.value;

                    config.headers = {
                        '__RequestVerificationToken': verificationToken
                    };
                }
            }

            if (typeof url === 'undefined') {
                deferred.reject({
                    'error': 'This control doesn\'t work with vti_bin'
                });
            } else {
                if (EnvironmentService.isSitecore && control === 'VerzekeringsKiezer') {
                    $http.get($window.location.origin + url, requestdata, config).then(function (result) {
                        if (result.status === 200) {
                            deferred.resolve(result.data);
                        } else {
                            deferred.reject({
                                'error': 'Something went wrong'
                            });
                        }
                    }, function (error) {
                        deferred.reject(error);
                    });
                } else {
                    $http.post($window.location.origin + url, requestdata, config).then(function (result) {
                        if (result.status === 200) {
                            deferred.resolve(result.data);
                        } else {
                            deferred.reject({
                                'error': 'Something went wrong'
                            });
                        }
                    }, function (error) {
                        deferred.reject(error);
                    });
                }
            }
        } else {
            // Environment is not PRD, ACC, TST or Proxy. Use mock.
            $log.warn('WebApiProxy ' + control + ' is undefined. Using mock');

            WebApiMockService.get(requestdata, control).then(function (data) {
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });
        }

        return deferred.promise;
    }

    // This function is used with the Sitecore SendTemplatedEmail API /apiproxy/achmea-outputmanagement-emailtemplate-v1-sendtemplatedemail
    function getParametersObject(data, prefix) {
        var object = {};

        _angular2.default.forEach(data, function (value, key) {
            //If value is moment object, convert to date string
            if (_moment2.default.isMoment(value)) {
                //moment date. Format as normal string
                value = (0, _moment2.default)(value, _moment2.default.ISO_8601).format('DD-MM-YYYY');
            }

            // skip undefined, null, empty strings, objects and arrays
            if (_angular2.default.isDefined(key) && key && _angular2.default.isDefined(value) && value && !_angular2.default.isObject(value) && !_angular2.default.isArray(value)) {
                // add key and value pair to Parameter object, add a prefix if needed
                if (_angular2.default.isDefined(prefix)) {
                    var key = prefix + key;
                    object[key] = value;
                } else {
                    object[key] = value;
                }
            }

            // if value is an array, recursivly create object for each item in array
            if (_angular2.default.isArray(value)) {
                for (var i = 0; i < value.length; i++) {
                    var tempObject = getParametersObject(value[i], key + '_' + (i + 1) + '_');
                    var cacheObject = object;
                    object = mergeObjects(tempObject, cacheObject);
                }
            }
        });
        return object;
    }

    function mergeObjects(obj1, obj2) {
        var result = {};
        var key;

        for (key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                result[key] = obj1[key];
            }
        }

        for (key in obj2) {
            if (obj2.hasOwnProperty(key)) {
                result[key] = obj2[key];
            }
        }

        return result;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/webapi/web-api.service.js
// module id = 839
// module chunks = 0